import {Dispatch, SetStateAction, useState, useCallback} from 'react';
import {ModalNameType} from '../constants';
import {useModalUI} from '../contexts/ModalUIProvider.client';

interface UseModalToggleType<T> {
  isOpen: boolean;
  openModal: (data?: T) => void;
  closeModal: (all?: boolean) => void;
  toggleModal: () => void;
  modalData: T;
  setModalData: Dispatch<SetStateAction<T>>;
}

export default function useModalToggle<T>(
  modalName: ModalNameType,
  data?: T,
): UseModalToggleType<T> {
  const {openModalUI, closeModalUI, toggleModalUI, openModalName} =
    useModalUI();
  const [modalData, setModalData] = useState<T>(data);

  const openModal = useCallback(
    (data?: T) => {
      if (data) setModalData(data);
      openModalUI(modalName);
    },
    [modalName, openModalUI],
  );

  const closeModal = useCallback(
    (all = false) => {
      closeModalUI(all ? null : modalName);
    },
    [closeModalUI, modalName],
  );

  const toggleModal = useCallback(
    () => toggleModalUI(modalName),
    [modalName, toggleModalUI],
  );

  return {
    isOpen: openModalName === modalName,
    openModal,
    closeModal,
    toggleModal,
    modalData,
    setModalData,
  };
}
